module.exports = __webpack_public_path__ + "static/media/fb.58532549.svg";